import Api from '~/config/Api'
const endpoint = Api.airports

export default {
  async fetch (airportCodes = []) {
    const { data } = await useApi(endpoint, {
      searchParams: {
        airports: airportCodes.join(',')
      }
    })

    return data
  },

  async detail (slug) {
    const detailEndpoint = endpoint + '/' + slug.toUpperCase()
    const { data } = await useApi(detailEndpoint)

    return data
  }
}
